
import cancelSVG from '~/assets/svg/cancel.svg?inline'
import checkmarkSVG from '~/assets/svg/checkmark.svg?inline'

export default {
  components: {
    cancelSVG,
    checkmarkSVG,
  },

  props: {
    text: {
      type: String,
      default: 'Button Text',
    },
    arialabel: {
      type: String,
      default: '',
    },
    primary: {
      type: Boolean,
    },
    secondary: {
      type: Boolean,
    },

    disabled: {
      type: Boolean,
    },

    altgreen: {
      type: Boolean,
    },

    black: {
      type: Boolean,
    },
    danger: {
      type: Boolean,
    },
    cancel: {
      type: Boolean,
    },
    checkmark: {
      type: Boolean,
    },
  },

  computed: {
    computedClass() {
      return {
        'btn--primary': this.primary,
        'btn--secondary': this.secondary,
        'btn--disabled': this.disabled,
        'btn--black': this.black,
        'btn--danger': this.danger,
      }
    },
  },

  methods: {
    onClick(e) {
      this.$emit('click', e)
    },
  },
}
